import { setCookie, customEncodeValue } from '../../util/cookies';
import { getREApiUrl } from '../../utilities';

const showErrorMessage = (message) => {
  const errorElem = document.querySelector('.FormBuilder-errorMessage');

  if (errorElem) {
    errorElem.style.display = 'block';

    if (message) {
      errorElem.textContent = message;
    }
  }
};

const showSuccessMessage = () => {
  const successMessage = document.getElementById("SuccessMessage")
  successMessage.style.display = 'block'
}

const hideForm = (form) => {
  form.style.display = "none";
};

const setReferralUrl = (referralUrl) => {
  const input = document.getElementById("referral_url");
  if (input) {
    input.value = referralUrl;
  }
};

const handleRedirect = (redirectUrl, referralUrl) => {
  if (redirectUrl) {
    setCookie("RSCMS_referral_url", customEncodeValue(referralUrl), {});
    window.location = redirectUrl;
  }
};

const setSuccessRedirectCookies = (responseBody, formData) => {
  // for form tracking
  setCookie("RSCMS_lead_id", customEncodeValue(responseBody.lead_id), {});
  setCookie("RSCMS_score", customEncodeValue(responseBody.score), {});
  setCookie("RSCMS_usState", customEncodeValue(responseBody.us_state), {});
  // for autofilling the next form
  setCookie("RSCMS_email", customEncodeValue(formData.get('email')), {});
  setCookie("RSCMS_firstName", customEncodeValue(formData.get('first_name')), {});
  setCookie("RSCMS_lastName", customEncodeValue(formData.get('last_name')), {});
  setCookie("RSCMS_orgName", customEncodeValue(formData.get('org_name')), {});
  setCookie("RSCMS_orgZip", customEncodeValue(formData.get('org_zip')), {});
  setCookie("RSCMS_phone", customEncodeValue(formData.get('phone')), {});
};

const handleSubmit = (form) => {
  const formData = new FormData(form);
  fetch(`${getREApiUrl()}/forms/fin_lit`, {
    method: 'POST',
    mode: 'cors',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(Object.fromEntries(formData))
  })
    .then((response) => {
      if (response.ok) {
        response.json().then((responseBody) => {
          if (responseBody.redirect_url) {
            setSuccessRedirectCookies(responseBody, formData);
            handleRedirect(
              responseBody.redirect_url,
              responseBody.referral_url
            );
          } else {
            form.dataset.analyticsFormCompletedId = responseBody.lead_id;
            form.dataset.analyticsFormCompletedScore = responseBody.score;
            form.dataset.usState = responseBody.us_state;
            showSuccessMessage();
            hideForm(form);
            setReferralUrl(responseBody.referral_url);
          }
        });
      } else {
        response.json().then((responseBody) => {
          showErrorMessage(responseBody.errors[0]);
        });
      }
    })
    .catch((error) => {
      console.error(error);
    });
};

export { handleSubmit };
